export const TOURS_CONFIG = {
  enabled: true, // muestra visita guiada
};
